import React from 'react';
import {ScrollView, View} from 'react-native';
import {useStyle} from 'src/providers/style';
import {
  StaffUtilization,
  NoteSubmissionRate,
  CancellationRate,
} from 'src/modules/practice-management/components/widgets';
import {compose} from 'recompose';
import {withDatabase} from '@nozbe/watermelondb/react';
import {withObservables} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {Q} from '@nozbe/watermelondb';
import {Appointment} from 'src/models';

const CoreBusinessHealth = ({
  sessionsCompleted,
  cancelledAppointments,
}: any) => {
  const styles = useStyle();

  return (
    <ScrollView>
      <View style={[styles.width, styles.flex, styles.paddingVertical]}>
        <CancellationRate appointments={cancelledAppointments} />
      </View>
      <View style={[styles.width, styles.flex, styles.paddingVertical]}>
        <StaffUtilization sessions={sessionsCompleted} />
      </View>
      <View style={[styles.container, styles.width, styles.marginTop]}>
        <View style={[styles.width, styles.flex]}>
          <NoteSubmissionRate sessions={sessionsCompleted} />
        </View>
      </View>
    </ScrollView>
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables(
    ['organization'],
    ({organization, database, authentication}: any) => ({
      sessionsCompleted: organization.sessionsCompleted(organization.partition),
      cancelledAppointments: database
        .get(Appointment.table)
        .query(
          Q.where('deleted_at', Q.notEq(null)),
          Q.where('_partition', authentication.selectedGroup),
        ),
    }),
  ),
)(CoreBusinessHealth);
